module.exports = "<ul class=\"tags-list\" data-bind=\"\">\n\t<!-- ko foreach: items -->\n\t<li class=\"tag\" data-bind=\"click: $parent.selection.handleClick, attr: {title: zde.lang('shop_filter_btn_cancel')}\">\n\t\t<span data-bind=\"text: title\"></span>\n\t\t<i class=\"icon--delete\"></i>\n\t</li>\n\t<!-- /ko -->\n\n\t<!-- ko if: showReset -->\n\t<li class=\"tag tag-reset\" data-bind=\"click: selection.reset, attr: {title: zde.lang('shop_filter_btn_cancel_all')}\">\n\t\t<span data-bind=\"lang: 'btn_reset'\"></span>\n\t</li>\n\t<!-- /ko -->\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./modules/shop/catalog/templates/filters/selection-items.html
// module id = FBgD
// module chunks = 8 9